<script>
	import Painel from './Painel.svelte';

	const opcoes = [
		{
			titulo: "Voltar", 
			icone: "voltar",
			link: "#/painel",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Cadastrar", 
			icone: "salvar",
			link: "#/grupos/cadastro",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Listar", 
			icone: "listar",
			link: "#/grupos/listagem",
			perfis: "CETREINA"
		},
	];
</script>

<Painel 
	titulo="Painel de Grupos" 
	listaFuncionalidades={opcoes}>
</Painel>
